import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.svg";
import '../styles/NotFound.css'

export default function NotFound() {
  return (
    <div className="NotFound">
        <div className="NotFound-title">
            <h1>404</h1>
            <h2>PAGE NOT FOUND</h2>
        </div>
        <Link to={`/`} className="NotFound-logo">
          <p>Go to</p>
          <div>
              <img src={logo} width={224} alt='Logo'></img>
          </div>
        </Link>
    </div>
  );
}